import axios from "../../../../api/axios";

export const visitUser = async (userId: string): Promise<void> => {
  try {
    const response = await axios.post<void>(`/users/${userId}/visited`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to record user visit: ${(err as Error).message}`);
  }
};
